module.exports = "//d274d294w9cx2v.cloudfront.net/c30b825300c823857ad792ec5ec01e2845b45cc0/images/registryDefaultSmall.webp";